import React, { FunctionComponent } from 'react'
import BodyFont from '../../../Theme/Fonts/Body'

const LoadingSpinner: FunctionComponent = () => (
    <BodyFont bold color="WHITE" textAlign="center">
        LoadingSpinner not supported on this platform
    </BodyFont>
)

export default LoadingSpinner
